import Logger from 'core/utils/Logger'
import { fail } from 'onboarding/classes/services/notification'
import { IValidationParamsErrorPayload } from 'onboarding/types/request'
import { convertErrorMessagesToHTMLList } from 'onboarding/utils/convertErrorMessagesToHTMLList'

export const handleApiResponse = <T>(response: any): T | null => {
  if (!response) throw new Error('Empty response from server')

  if (response.status === 'success') {
    return response.data as T
  }

  if (response.status === 'fail') {
    Logger.warn(response.data)
    if ('messages' in response.data && Array.isArray(response.data.messages)) {
      fail(convertErrorMessagesToHTMLList(response.data.messages))
    } else if (Array.isArray(response.data)) {
      fail(convertErrorMessagesToHTMLList(response.data as IValidationParamsErrorPayload[]))
    } else {
      fail('Unknown error format from server')
    }

    return null
  }

  throw new Error(response.message ?? 'System error')
}
